module.exports = __webpack_public_path__ + "images/emoji/guitar.c6ea04b421cfe7ef5731.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/guitar.png
// module id = gP60
// module chunks = 1